import { initializeCart } from '../updateCart';

const shopCurrency = document.querySelector('body').dataset.currency;

export default class QuickView {
  constructor(query) {
    this.quickviewModals = document.querySelectorAll(query);
    if (!this.quickviewModals) return;

    // --------------- Attach event listeners --------------- //
    this.quickviewModals.forEach((modal) => {
      const closeModalButton = modal.querySelector('button.close-modal');
      const modalContent = modal.querySelector('.content');
      const selectedImage = modal.querySelector('.hero-selected-img');
      const thumbnails = modal.querySelectorAll('.hero-carousel img');
      const variantOptions = modal.querySelectorAll('.variant-selector .options-container div');
      const sizeVariantSelector = modal.querySelector('.variant-selector.size .dropdown');
      const addToCartButton = modal.querySelector('.product-form--submit button');
      const addToCartButtonBundle = modal.querySelector('.product-form--submit-bundle button');

      closeModalButton.addEventListener('click', this.closeModal.bind(this));
      modal.addEventListener('click', this.closeModal.bind(this));
      modalContent.addEventListener('click', (e) => e.stopPropagation());
      // selectedImage.addEventListener('load', this.resetAnimation.bind(this));
      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', this.swapHeroImage.bind(this));
      });

      variantOptions.forEach((option) => {
        option.addEventListener('click', (e) => this.previewVariant(modal, e.target, undefined));
      });

      if (sizeVariantSelector) {
        sizeVariantSelector.addEventListener(
          'click',
          this.toggleSizeVariantDropdown.bind(this, modal)
        );
      }

      if(addToCartButton){
        addToCartButton.addEventListener('click', this.submitOrder.bind(this, modal));
      }
    });
  }

  // --------------- Event handlers --------------- //
  /**
   * Close popup modal
   */
  closeModal(e) {
    let el = e.target;
    while(!el.classList.contains('modal')) el = el.parentElement;

    el.classList.add('out');

    setTimeout(() => {
      el.style.display = 'none';
      el.classList.remove('out');
    }, 250);
  }

  /**
   * Reset animation
   */
  resetAnimation(e) {
    const el = e.target;

    el.style.animation = 'none';
    el.offsetHeight;
    el.style.animation = null;
  }

  /**
   * Switch selected image on hero module upon clicking thumbnail
   */
  swapHeroImage(e) {
    let selectedImg = e.target;
    const imgSrc = e.target.dataset.src;
    const imgIndex = e.target.dataset.index;

    while (!selectedImg.classList.contains('hero-carousel')) {
      selectedImg = selectedImg.parentElement;
    }

    selectedImg = selectedImg.previousElementSibling;
    selectedImg.src = imgSrc;
    selectedImg.alt = selectedImg.dataset.alt + ' ' + imgIndex;
  }

  /**
   * Get selected variant id
   */
  getSelectedVariantId(modal, target) {
    let selectedColor = modal.querySelector('.variant-selector.color .selected');
    let selectedSize = modal.querySelector('.variant-selector.size .selected');
    if (selectedColor) selectedColor = selectedColor.dataset.value;
    if (selectedSize) selectedSize = selectedSize.dataset.value;
    const productName = modal.querySelector('.hero-desc--container h1').innerText;

    let parent = target;
    while (!parent.classList.contains('variant-selector')) {
      parent = parent.parentElement;
    }

    if (parent.classList.contains('color')) {
      selectedColor = target.dataset.value;

      parent.querySelectorAll('.options-container div').forEach((el) => {
        el.classList.remove('selected');
      });

      parent.querySelector('h6 span').innerText = selectedColor;
      target.classList.add('selected');

      const heroEyebrow = modal.querySelector('.hero-selected-img').dataset.heroEyebrow != '' ? ' ' + modal.querySelector('.hero-selected-img').dataset.heroEyebrow  : '';
      const variantTitle = selectedColor != undefined && selectedColor != 'Default Title' ? ` ${selectedColor}` : '';

      modal.querySelector('.hero-selected-img').alt = `Korres${heroEyebrow}${variantTitle} ${productName} 01`;
      modal.querySelector('.hero-selected-img').dataset.alt = `Korres${heroEyebrow}${variantTitle} ${productName}`;
    } else if (parent.classList.contains('size')) {
      selectedSize = target.dataset.value;

      parent.querySelector('.dropdown .value').innerText = target.innerText || target.textContent || selectedSize;

      const heroEyebrow = modal.querySelector('.hero-selected-img').dataset.heroEyebrow != '' ? ' ' + modal.querySelector('.hero-selected-img').dataset.heroEyebrow : '';
      const variantTitle = selectedSize != undefined && selectedSize != 'Default Title' ? ` ${selectedSize}` : '';

      modal.querySelector('.hero-selected-img').alt = `Korres${heroEyebrow}${variantTitle} ${productName} 01`;
      modal.querySelector('.hero-selected-img').dataset.alt = `Korres${heroEyebrow}${variantTitle} ${productName}`;
    }

    const variants = modal.querySelector('form select[name="id"]').options;
    const variantSize = variants.length;

    for (let i = 0; i < variantSize; i++) {
      if (selectedColor && !variants[i].text.includes(selectedColor)) {
        continue;
      }

      if (selectedSize && !variants[i].text.includes(selectedSize)) {
        continue;
      }

      variants[i].selected = true;
      return variants[i].value;
    }
  }

  /**
   * Dynamically change modal content based on selected variant
   */
  previewVariant(modal, target, variantId) {
    if (!variantId) {
      variantId = this.getSelectedVariantId(modal, target);
    } else {
      // Update variant selector selected value
      const selectedIdOptions = modal.querySelector('form select[name="id"]').options;
      const optionSize = selectedIdOptions.length;
      let selectedVariant;

      for (let i = 0; i < optionSize; i++) {
        if (selectedIdOptions[i].value === variantId) {
          selectedIdOptions[i].selected = true;
          selectedVariant = selectedIdOptions[i].innerText;
        }
      }

      const color = modal.querySelector('.variant-selector.color');
      if (color) {
        const colorOptions = color.querySelectorAll('.options-container div');
        color.querySelector('h6 span').innerText = selectedVariant;

        colorOptions.forEach((el) => {
          if (el.dataset.value === selectedVariant) {
            el.classList.add('selected');
          } else el.classList.remove('selected');
        });
      }

      const size = modal.querySelector('.variant-selector.size');
      if (size) {
        size.querySelector('.dropdown .value').innerText = selectedVariant;
      }

      const heroEyebrow = modal.querySelector('.hero-selected-img').dataset.heroEyebrow != '' ? ' ' + modal.querySelector('.hero-selected-img').dataset.heroEyebrow : '';
      const variantTitle = selectedVariant != undefined && selectedVariant != 'Default Title' ? ` ${selectedVariant}` : '';
      const productName = modal.querySelector('.hero-desc--container h1').innerText;

      modal.querySelector('.hero-selected-img').alt = `Korres${heroEyebrow}${variantTitle} ${productName} 01`;
      modal.querySelector('.hero-selected-img').dataset.alt = `Korres${heroEyebrow}${variantTitle} ${productName}`;
    }

    const productName = modal.querySelector('.hero-desc--container h1').innerText;
    const images = document.querySelector(`#modal-img-${variantId}`).value.split('|');
    const summary = document.querySelector(`#modal-summary-${variantId}`).value;
    const price = document.querySelector(`#modal-price-${variantId}`).value;
    const isAvailable = price !== 'unavailable';
    let ssprice = document.querySelector(`#modal-ssprice-${variantId}`);
    if (ssprice) ssprice = ssprice.value;

    // Update images
    modal.querySelector('.hero-selected-img').src = images[0];

    const thumbnailContainer = modal.querySelector('.hero-carousel');
    while (thumbnailContainer.firstChild) {
      thumbnailContainer.removeChild(thumbnailContainer.firstChild);
    }

    images.forEach((image, index) => {
      const img = document.createElement('img');
      img.setAttribute('src', `//images.accentuate.io?c_options=w_132&image=${image}`);
      img.setAttribute('data-src', image);
      img.setAttribute('alt', `${productName} thumbnail ${index}`);
      img.setAttribute('data-index', (index + 1) > 9 ? (index + 1) : `0${(index + 1)}`);

      thumbnailContainer.appendChild(img);
    });

    // Update summary
    modal.querySelector('.hero-desc--container .summary').innerText = summary;

    // Update add to cart button
    const addToCartButton = modal.querySelector('.product-form--submit button');

    if (!isAvailable) {
      addToCartButton.innerHTML = 'Out of Stock';
      addToCartButton.disabled = true;
    } else {
      addToCartButton.innerHTML = `
        Add To Cart - <span class="price">${price}</span>
        ${ssprice ? `<span class="ss-price">${ssprice}</span>` : ''}
      `;
      addToCartButton.disabled = false;
    }

    // Re-attach event listener for newly added elements
    const thumbnails = modal.querySelectorAll('.hero-carousel img');

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', this.swapHeroImage.bind(this));
    });
  }

  /**
   * Toggle size selector dropdown on desktop
   */
  toggleSizeVariantDropdown(modal, e) {
    e.stopPropagation();

    const el = modal.querySelector('.variant-selector.size .options-container');
    el.classList.toggle('show');
  }

  /**
   * Handle add to cart button using Shopify Ajax API
   */
  submitOrder(modal, e) {
    e.preventDefault();

    let variantId;
    let properties;
    const purchaseType = modal.querySelector('form [name="purchase_type"]');
    const shippingIntervalUnit = modal.querySelector('form .shipping_interval_unit_type');
    const shippingIntervalFrequency = modal.querySelector('form .shipping_interval_frequency');
    const variants = modal.querySelector('form select[name="id"]');
    const isSubscription = purchaseType.value === 'autodeliver';
    const selectedVariantIndex = variants.selectedIndex;
    const variantOptions = variants.options;
    const custom_quantity = modal.querySelector('form input[name="quantity"]').value;

    if (isSubscription) {
      variantId = variantOptions[selectedVariantIndex].dataset.value;

      properties = {
        shipping_interval_frequency: shippingIntervalFrequency.value,
        shipping_interval_unit_type: shippingIntervalUnit.value
      };
    } else {
      variantId = variantOptions[selectedVariantIndex].value;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        quantity: custom_quantity,
        id: variantId,
        properties
      })
    })
      .then((res) => {
        if (res.ok) return res.json();
        else throw Error(`Request rejected with status ${res.status}`);
      })
      .then((res) => {
        // Close quickview modal
        modal.classList.add('out');

        var finalPrice = (res.final_price / 100.00).toFixed(2);

        snaptr('track','ADD_CART', {
          'currency': shopCurrency,
          'price': finalPrice
        });


        setTimeout(() => {
          modal.style.display = 'none';
          modal.classList.remove('out');
        }, 250);

        // Show mini-cart
        initializeCart();
        document.body.classList.add('cart-open');
        document.getElementById('shopify-section-cart').classList.add('show');
      })
      .catch(console.log);
  }


}
